import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Photo, ProcessedAclRole } from './interfaces';
import { observeProcessedEventAclRole } from '../eventDataSourceUpgrades/observeProcessedEventAclRole'
import { Channel, IChannel } from './eventChannel';
import 'rxjs/add/operator/pluck';
import 'rxjs/add/operator/distinctUntilChanged';

export interface Photo {
    key: string;
    assetId: string;
    height: number;
    width: number;
    size: number;
    mimetype: string;
    originalAssetId?: string;
    originalAssetMetadata?: {
        height: number;
        width: number;
        size: number;
        mimetype: string;
    }
}

export class EventSource {

    private ds;

    private publicInfo$: Observable<any>;
    private security$: Observable<any>;
    private pagesVisibility$: Observable<any>;
    private pagesConfig$: Observable<any>;
    private faqPage$: Observable<any>;
    private registryPage$: Observable<any>;
    private observeRegistryHasItems$: Observable<any>;
    private observeRegistryPageShouldDisplay$: Observable<any>;
    private schedulePage$: Observable<any>;
    private storyPage$: Observable<any>;
    private travelPage$: Observable<any>;
    private vipPage$: Observable<any>;
    private eventAclRole$: Observable<any>;
    private rsvpOverrides$: Observable<any>;
    private moments$: Observable<any>;
    private engagementMoments$: Observable<any>;
    private moments: IChannel;
    private engagementMoments: IChannel;

    public init(dataSource) {
        this.ds = dataSource;
        this.publicInfo$ = this.ds.observeInfo$();
        this.security$ = this.ds.observeSecuritySettings$();
        this.pagesVisibility$ = this.ds.observePageVisibilities$();
        this.pagesConfig$ = this.ds.observePageConfig$();
        this.faqPage$ = this.ds.observeFaqs$();
        this.registryPage$ = this.ds.observeRegistry$();
        this.observeRegistryHasItems$ = this.ds.observeRegistryHasItems$();
        this.observeRegistryPageShouldDisplay$ = this.ds.observeRegistryPageShouldDisplay$();
        this.schedulePage$ = this.ds.observeSchedule$();
        this.storyPage$ = this.ds.observeStoryPage$();
        this.travelPage$ = this.ds.observeTravel$();
        this.eventAclRole$ = this.ds.observeEventAclRole$();
        this.rsvpOverrides$ = this.ds.observeRsvpQuestionOverrides$();
        this.vipPage$ = this.ds.observeVip$();
        this.moments = new Channel(this.ds, "moments");
        this.engagementMoments = new Channel(this.ds, "engagementMoments");
        this.moments$ = this.moments.observeMessages$();
        this.engagementMoments$ = this.engagementMoments.observeMessages$();
    }

    public getDatasource() {
        return this.ds;
    }
    public observePublicInfo() {
        return this.publicInfo$
    }

    public observeSecurity() {
        return this.security$;
    }
    public observePagesVisibility() {
        return this.pagesVisibility$;
    }

    public observePagesConfig() {
        return this.pagesConfig$;
    }

    public observeFaqPage() {
        return this.faqPage$;
    }

    public observeRegistryPage() {
        return this.registryPage$;
    }

    public observeRegistryHasItems() {
        return this.observeRegistryHasItems$;
    }

    public observeRegistryPageShouldDisplay() {
        return this.observeRegistryPageShouldDisplay$;
    }

    public observeSchedulePage() {
        return this.schedulePage$;
    }

    public observeStoryPage() {
        return this.storyPage$;
    }

    public observeEventAclRole() {
        return this.eventAclRole$;
    }

    public observeTravelPage() {
        return this.travelPage$;
    }

    public observeVipPage() {
        return this.vipPage$;
    }

    public rsvpOverrides() {
        return this.vipPage$;
    }

    public observeMoments() {
        return this.moments$;
    }

    public observeEngagementMoments() {
        return this.engagementMoments$;
    }

    public pluckPublicInfo(key: Array<string>) {
        return this.pluckData(this.observePublicInfo(), key);
    }

    public pluckSecurity(key: Array<string>) {
        return this.pluckData(this.observeSecurity(), key);
    }

    public pluckData(data: Observable<any>, key: Array<string>) {
        return data.pluck(...key).map(res => JSON.stringify(res)).distinctUntilChanged().map(json => json ? JSON.parse(json): {});
    }

    public observePrimaryPhoto(data: Observable<any>): Observable<Photo> {
        return this.pluckData(data, ['primaryPhoto'])
    }

    public observePrimaryPhotoHorizontal(data: Observable<any>): Observable<Photo> {
        return this.pluckData(data, ['primaryPhotoHorizontal'])
    }

    public getMomentsChannel(): IChannel {
        return this.moments;
    }

    public getEngagementMomentsChannel(): IChannel {
        return this.engagementMoments;
    }

}
